import React from 'react';
import { FaFacebook, FaTwitter, FaWhatsapp, FaEnvelope, FaLink, FaTimes } from 'react-icons/fa';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, EmailShareButton } from 'react-share';
import { sharePhoto } from '../services/api';
import { toast } from 'react-toastify';

function ShareMenu({ photoId, photoUrl, onClose }) {
  const shareUrl = `${window.location.origin}/photo/${photoId}`;
  const title = 'Check out this amazing photo from PhotoMatch!';

  const handleShare = async (platform) => {
    try {
      await sharePhoto(photoId, platform);
    } catch (error) {
      console.error('Error tracking share:', error);
    }
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      await sharePhoto(photoId, 'link');
      toast.success('Link copied to clipboard!');
      onClose();
    } catch (error) {
      toast.error('Failed to copy link');
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'transparent',
          zIndex: 999
        }}
      />

      {/* Menu */}
      <div style={{
        position: 'absolute',
        bottom: '60px',
        right: 0,
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        padding: '1rem',
        minWidth: '200px',
        zIndex: 1000
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1rem',
          paddingBottom: '0.5rem',
          borderBottom: '1px solid #eee'
        }}>
          <h4 style={{ margin: 0, color: '#424242' }}>Share Photo</h4>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontSize: '1.2rem',
              color: '#757575'
            }}
          >
            <FaTimes />
          </button>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem'
        }}>
          <FacebookShareButton
            url={shareUrl}
            quote={title}
            onClick={() => handleShare('facebook')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaFacebook style={{ fontSize: '1.5rem', color: '#1877F2' }} />
            <span style={{ color: '#424242', fontWeight: '500' }}>Facebook</span>
          </FacebookShareButton>

          <TwitterShareButton
            url={shareUrl}
            title={title}
            onClick={() => handleShare('twitter')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaTwitter style={{ fontSize: '1.5rem', color: '#1DA1F2' }} />
            <span style={{ color: '#424242', fontWeight: '500' }}>Twitter</span>
          </TwitterShareButton>

          <WhatsappShareButton
            url={shareUrl}
            title={title}
            onClick={() => handleShare('whatsapp')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaWhatsapp style={{ fontSize: '1.5rem', color: '#25D366' }} />
            <span style={{ color: '#424242', fontWeight: '500' }}>WhatsApp</span>
          </WhatsappShareButton>

          <EmailShareButton
            url={shareUrl}
            subject={title}
            body={`Check out this photo: ${shareUrl}`}
            onClick={() => handleShare('email')}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaEnvelope style={{ fontSize: '1.5rem', color: '#EA4335' }} />
            <span style={{ color: '#424242', fontWeight: '500' }}>Email</span>
          </EmailShareButton>

          <button
            onClick={copyToClipboard}
            style={{
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '0.8rem',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              cursor: 'pointer',
              borderRadius: '8px',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#f5f5f5'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}
          >
            <FaLink style={{ fontSize: '1.5rem', color: '#FF8C42' }} />
            <span style={{ color: '#424242', fontWeight: '500' }}>Copy Link</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default ShareMenu;
